import { render, staticRenderFns } from "./TilePackage.vue?vue&type=template&id=31cba71e&scoped=true&"
import script from "./TilePackage.vue?vue&type=script&lang=js&"
export * from "./TilePackage.vue?vue&type=script&lang=js&"
import style0 from "./TilePackage.vue?vue&type=style&index=0&id=31cba71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cba71e",
  null
  
)

export default component.exports